import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'
import { hasRoutePermission, hasRoutePermissionAsync } from '../utils/permission'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import SysUserManagement from '../views/SysUserManagement.vue'
import SysMenuManagement from '../views/SysMenuManagement.vue'
import SysRoleManagement from '../views/SysRoleManagement.vue'
import SysPermissionManagement from '../views/SysPermissionManagement.vue'
import CompanyManagement from '../views/CompanyManagement.vue'
import OperationLogManagement from '../views/OperationLogManagement.vue'
import FeedbackManagement from '../views/FeedbackManagement.vue'
import DataReport from '../views/DataReport.vue'
import ScheduledTaskManagement from '../views/ScheduledTaskManagement.vue'
import MembershipManagement from '../views/MembershipManagement.vue'
import ApprovalFlowConfigManagement from '../views/ApprovalFlowConfigManagement.vue'
import ManagerUserManagement from '../views/ManagerUserManagement.vue'
import ManagerOrgDeptManagement from '../views/ManagerOrgDeptManagement.vue'
import ManagerCompany from '../views/ManagerCompany.vue'
import ManagerReport from '../views/ManagerReport.vue'
import ManagerCustomerManagement from '../views/ManagerCustomerManagement.vue'
import SalesmanCustomerManagement from '../views/SalesmanCustomerManagement.vue'
import SalesmanContractManagement from '../views/SalesmanContractManagement.vue'
import SalesmanContractForm from '../views/SalesmanContractForm.vue'
import SalesmanFollowManagement from '../views/SalesmanFollowManagement.vue'
import SalesmanTravelExpenseManagement from '../views/SalesmanTravelExpenseManagement.vue'
import SalesmanBusinessTripManagement from '../views/SalesmanBusinessTripManagement.vue'
import SalesmanReturnOrderManagement from '../views/SalesmanReturnOrderManagement.vue'
import SalesmanReturnOrderForm from '../views/SalesmanReturnOrderForm.vue'
import SalesmanDealRecordManagement from '../views/SalesmanDealRecordManagement.vue'
import SalesmanReportManagement from '../views/SalesmanReportManagement.vue'
import InternalApprovalManagement from '../views/InternalApprovalManagement.vue'
import ApprovalManagement from '../views/ApprovalManagement.vue'
import ApprovalDetail from '../views/ApprovalDetail.vue'
import InternalWarehouseManagement from '../views/InternalWarehouseManagement.vue'
import InternalProductManagement from '../views/InternalProductManagement.vue'
import InternalDeliveryManagement from '../views/InternalDeliveryManagement.vue'
import InternalPurchaseManagement from '../views/InternalPurchaseManagement.vue'
import MessageCenter from '../views/MessageCenter.vue'
import MessageCategoryDetail from '../views/MessageCategoryDetail.vue'
import PurchaseDailyReport from '../views/PurchaseDailyReport.vue'
import CompanyAnnualReport from '../views/CompanyAnnualReport.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'sys-user',
        name: 'SysUserManagement',
        component: SysUserManagement,
        meta: { requiresAuth: true, requiresSystemAdmin: true, keepAlive: true }
      },
      {
        path: 'sys-menu',
        name: 'SysMenuManagement',
        component: SysMenuManagement,
        meta: { requiresAuth: true, requiresSystemAdmin: true, keepAlive: true }
      },
      {
        path: 'sys-role',
        name: 'SysRoleManagement',
        component: SysRoleManagement,
        meta: { requiresAuth: true, requiresSystemAdmin: true, keepAlive: true }
      },
      {
        path: 'sys-permission',
        name: 'SysPermissionManagement',
        component: SysPermissionManagement,
        meta: { requiresAuth: true, requiresSystemAdmin: true, keepAlive: true }
      },
      {
        path: 'company',
        name: 'CompanyManagement',
        component: CompanyManagement,
        meta: { requiresAuth: true, requiresSystemAdmin: true, keepAlive: true }
      },
      {
        path: 'operation-log',
        name: 'OperationLogManagement',
        component: OperationLogManagement,
        meta: { requiresAuth: true, requiresSystemAdmin: true, keepAlive: true }
      },
      {
        path: 'feedback',
        name: 'FeedbackManagement',
        component: FeedbackManagement,
        meta: { requiresAuth: true, requiresSystemAdmin: true, keepAlive: true }
      },
      {
        path: 'data-report',
        name: 'DataReport',
        component: DataReport,
        meta: { requiresAuth: true, requiresSystemAdmin: true, keepAlive: true }
      },
      {
        path: 'scheduled-task',
        name: 'ScheduledTaskManagement',
        component: ScheduledTaskManagement,
        meta: { requiresAuth: true, requiresSystemAdmin: true, keepAlive: true }
      },
      {
        path: 'membership',
        name: 'MembershipManagement',
        component: MembershipManagement,
        meta: { requiresAuth: true, requiresSystemAdmin: true, keepAlive: true }
      },
      {
        path: 'approval-flow-config',
        name: 'ApprovalFlowConfigManagement',
        component: ApprovalFlowConfigManagement,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        // 兼容旧路径
        path: 'workflow',
        redirect: { name: 'ApprovalFlowConfigManagement' }
      },
      {
        // 兼容旧路径
        path: 'member',
        redirect: { name: 'MembershipManagement' }
      },
      {
        path: 'manager-user',
        name: 'ManagerUserManagement',
        component: ManagerUserManagement,
        meta: { requiresAuth: true, requiresManager: true, keepAlive: true },
        alias: ['manager/user']
      },
      {
        path: 'manager-org-dept',
        name: 'ManagerOrgDeptManagement',
        component: ManagerOrgDeptManagement,
        meta: { requiresAuth: true, requiresManager: true, keepAlive: true },
        alias: ['manager/org/dept']
      },
      {
        path: 'manager-company',
        name: 'ManagerCompany',
        component: ManagerCompany,
        meta: { requiresAuth: true, requiresManager: true, keepAlive: true },
        alias: ['manager/company']
      },
      {
        path: 'manager-report',
        name: 'ManagerReport',
        component: ManagerReport,
        meta: { requiresAuth: true, requiresManager: true, keepAlive: true },
        alias: ['manager/report']
      },
      {
        path: 'manager-customer',
        name: 'ManagerCustomerManagement',
        component: ManagerCustomerManagement,
        meta: { requiresAuth: true, requiresManager: true, keepAlive: true },
        alias: ['manager/customer']
      },
      {
        path: 'salesman-customer',
        name: 'SalesmanCustomerManagement',
        component: SalesmanCustomerManagement,
        meta: { requiresAuth: true, requiresSalesman: true, keepAlive: true }
      },
      {
        path: 'salesman-contract',
        name: 'SalesmanContractManagement',
        component: SalesmanContractManagement,
        meta: { requiresAuth: true, requiresSalesman: true, keepAlive: true }
      },
      {
        path: 'salesman-contract-form',
        name: 'SalesmanContractForm',
        component: SalesmanContractForm,
        meta: { requiresAuth: true, requiresSalesman: true }
      },
      {
        path: 'salesman-follow',
        name: 'SalesmanFollowManagement',
        component: SalesmanFollowManagement,
        meta: { requiresAuth: true, requiresSalesman: true, keepAlive: true }
      },
      {
        path: 'salesman-travel-expense',
        name: 'SalesmanTravelExpenseManagement',
        component: SalesmanTravelExpenseManagement,
        meta: { requiresAuth: true, requiresSalesman: true, keepAlive: true }
      },
      {
        path: 'salesman-business-trip',
        name: 'SalesmanBusinessTripManagement',
        component: SalesmanBusinessTripManagement,
        meta: { requiresAuth: true, requiresSalesman: true, keepAlive: true }
      },
      {
        // 兼容旧路径 /home/salesman-trip
        path: 'salesman-trip',
        redirect: { name: 'SalesmanBusinessTripManagement' }
      },
      {
        path: 'salesman-return-order',
        name: 'SalesmanReturnOrderManagement',
        component: SalesmanReturnOrderManagement,
        meta: { requiresAuth: true, requiresSalesman: true, keepAlive: true }
      },
      {
        path: 'salesman-return-order-form',
        name: 'SalesmanReturnOrderForm',
        component: SalesmanReturnOrderForm,
        meta: { requiresAuth: true, requiresSalesman: true }
      },
      {
        // 兼容旧路径 /home/salesman-return
        path: 'salesman-return',
        redirect: { name: 'SalesmanReturnOrderManagement' }
      },
      {
        path: 'salesman-deal-record',
        name: 'SalesmanDealRecordManagement',
        component: SalesmanDealRecordManagement,
        meta: { requiresAuth: true, requiresSalesman: true, keepAlive: true }
      },
      {
        // 兼容旧路径 /home/salesman-deal
        path: 'salesman-deal',
        redirect: { name: 'SalesmanDealRecordManagement' }
      },
      {
        path: 'salesman-report',
        name: 'SalesmanReportManagement',
        component: SalesmanReportManagement,
        meta: { requiresAuth: true, requiresSalesman: true, keepAlive: true }
      },
      {
        path: 'internal-approval',
        name: 'InternalApprovalManagement',
        component: InternalApprovalManagement,
        meta: { requiresAuth: true, requiresApprovalAccess: true, keepAlive: true }
      },
      {
        path: 'manager-approval',
        name: 'ManagerApprovalManagement',
        component: ApprovalManagement,
        meta: { requiresAuth: true, requiresApprovalAccess: true, keepAlive: true }
      },
      {
        path: 'approval-detail/:id',
        name: 'ApprovalDetail',
        component: ApprovalDetail,
        meta: { requiresAuth: true, requiresApprovalAccess: true }
      },
      {
        path: 'internal-warehouse',
        name: 'InternalWarehouseManagement',
        component: InternalWarehouseManagement,
        meta: { requiresAuth: true, requiresAssistant: true, keepAlive: true },
        alias: ['assistant/warehouse']
      },
      {
        path: 'internal-product',
        name: 'InternalProductManagement',
        component: InternalProductManagement,
        meta: { requiresAuth: true, requiresAssistant: true, keepAlive: true },
        alias: ['assistant/product']
      },
      {
        path: 'salesman-product',
        name: 'SalesmanProductManagement',
        component: InternalProductManagement,
        meta: { requiresAuth: true, requiresSalesman: true, keepAlive: true }
      },
      {
        path: 'internal-delivery',
        name: 'InternalDeliveryManagement',
        component: InternalDeliveryManagement,
        meta: { requiresAuth: true, requiresAssistant: true, keepAlive: true },
        alias: ['assistant/delivery']
      },
      {
        path: 'internal-purchase',
        name: 'InternalPurchaseManagement',
        component: InternalPurchaseManagement,
        meta: { requiresAuth: true, requiresAssistant: true, keepAlive: true },
        alias: ['assistant/purchase']
      },
      {
        // 兼容助手审批路径，重定向到内部审批管理
        path: 'assistant/approval',
        redirect: { name: 'InternalApprovalManagement' }
      },
      {
        path: 'message-center',
        name: 'MessageCenter',
        component: MessageCenter,
        meta: { requiresAuth: true, requiresSalesman: true, keepAlive: true }
      },
      {
        path: 'message-center/detail',
        name: 'MessageCategoryDetail',
        component: MessageCategoryDetail,
        meta: { requiresAuth: true, requiresSalesman: true }
      },
      {
        // 会计相关路由
        path: 'accountant/purchase-daily',
        name: 'PurchaseDailyReport',
        component: PurchaseDailyReport,
        meta: { requiresAuth: true, keepAlive: true }
      },
      {
        path: 'accountant/annual-report',
        name: 'CompanyAnnualReport',
        component: CompanyAnnualReport,
        meta: { requiresAuth: true, keepAlive: true }
      }
    ]
  },
  {
    // 为了兼容，保留独立路由
    path: '/sys-user',
    redirect: '/home/sys-user'
  },
  {
    // 为了兼容，保留独立路由
    path: '/home/member',
    redirect: '/home/membership'
  },
  {
    // 为了兼容，保留独立路由
    path: '/home/workflow',
    redirect: '/home/approval-flow-config'
  },
  {
    // 为了兼容，保留独立路由
    path: '/home/manager-account',
    redirect: '/home/manager-user'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫：基于菜单权限验证
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('accessToken')
  
  // 1. 检查是否需要登录
  if (to.meta.requiresAuth && !token) {
    // 需要登录但没有token，跳转到登录页
    next('/login')
    return
  }
  
  // 2. 已登录但访问登录页的处理
  if (to.path === '/login' && token) {
    // 先检查会员状态，如果会员过期，清除token并允许访问登录页（不跳转首页）
    try {
      const userInfoStr = localStorage.getItem('userInfo')
      if (userInfoStr) {
        const userInfo = JSON.parse(userInfoStr)
        const isMember = userInfo.isMember
        const memberLevel = userInfo.memberLevel
        const userType = userInfo.userType
        
        // 系统管理员不受会员限制，直接跳转到首页
        if (userType === 'SYSTEM_ADMIN') {
          next('/home')
          return
        }
        
        // 如果用户不是会员或会员信息缺失，清除token并允许访问登录页（不显示提示，让用户在登录时检查）
        if (!isMember || isMember === 0 || !memberLevel) {
          // 清除token和用户信息
          localStorage.removeItem('accessToken')
          localStorage.removeItem('refreshToken')
          localStorage.removeItem('userInfo')
          // 允许访问登录页，不跳转首页
          next()
          return
        }
      }
    } catch (e) {
      console.warn('检查会员状态失败:', e)
      // 如果解析用户信息失败，清除token并允许访问登录页
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('userInfo')
      next()
      return
    }
    
    // 会员状态正常，跳转到首页
    next('/home')
    return
  }
  
  // 3. 如果不需要登录验证，直接通过
  if (!to.meta.requiresAuth) {
    next()
    return
  }
  
  // 4. PC系统会员状态检查：普通用户或会员过期的用户不允许使用PC系统
  if (token) {
    try {
      const userInfoStr = localStorage.getItem('userInfo')
      if (userInfoStr) {
        const userInfo = JSON.parse(userInfoStr)
        const isMember = userInfo.isMember
        const memberLevel = userInfo.memberLevel
        const userType = userInfo.userType
        
        // 系统管理员不受会员限制
        if (userType !== 'SYSTEM_ADMIN') {
          // 如果用户不是会员或会员信息缺失，阻止访问并跳转到登录页
          if (!isMember || isMember === 0 || !memberLevel) {
            // 清除token和用户信息
            localStorage.removeItem('accessToken')
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('userInfo')
            
            // 跳转到登录页
            next('/login')
            return
          }
        }
      }
    } catch (e) {
      console.warn('检查会员状态失败:', e)
      // 如果解析用户信息失败，清除token并跳转到登录页
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('userInfo')
      next('/login')
      return
    }
  }
  
  // 5. 需要权限验证的路由，基于菜单权限检查
  if (token) {
    try {
      // 获取用户信息，检查用户角色
      let userInfo = null
      try {
        const userInfoStr = localStorage.getItem('userInfo')
        if (userInfoStr) {
          userInfo = JSON.parse(userInfoStr)
        }
      } catch (e) {
        console.warn('解析用户信息失败:', e)
      }
      
      const userType = userInfo?.userType || ''
      const userTypeUpper = userType.toUpperCase()
      
      // 特殊处理：审批管理相关路由，ASSISTANT、ACCOUNTANT、MANAGER 角色直接允许访问（无需菜单权限）
      if (to.meta.requiresApprovalAccess) {
        if (userTypeUpper === 'ASSISTANT' || userTypeUpper === 'ACCOUNTANT' || userTypeUpper === 'MANAGER') {
          // 内勤、会计、管理员角色直接允许访问审批管理
          next()
          return
        }
      }
      
      // 特殊处理：内勤相关路由，ASSISTANT 角色直接允许访问（无需菜单权限）
      if (to.meta.requiresAssistant) {
        if (userTypeUpper === 'ASSISTANT') {
          // 内勤角色直接允许访问内勤相关页面
          next()
          return
        }
      }
      
      // 先尝试从localStorage获取菜单列表进行快速检查
      let hasPermission = hasRoutePermission(to.path)
      
      // 如果快速检查失败，尝试异步获取菜单列表（可能是首次访问或菜单已更新）
      if (!hasPermission) {
        hasPermission = await hasRoutePermissionAsync(to.path)
      }
      
      if (hasPermission) {
        next()
      } else {
        // 无权限访问
        ElMessage.warning('无权限访问该页面，请联系管理员分配菜单权限')
        // 如果是从其他页面跳转过来的，返回上一页；否则跳转到首页
        if (from.path && from.path !== '/login') {
          next(from.path)
        } else {
          next('/home')
        }
      }
    } catch (error) {
      console.error('权限检查失败:', error)
      ElMessage.error('权限验证失败，请重新登录')
      next('/login')
    }
  } else {
    next('/login')
  }
})

export default router

